// These are not all modals and their respective ids!
export const MODAL_IDS = {
    // General
    BackupCode: 'BackupCode',
    RemoveBackupCode: 'RemoveBackupCode',
    ChangePassword: 'ChangePassword',
    WorkspaceLeave: 'WorkspaceLeave',
    // Invitations
    InviteMembers: 'InviteMembers',
    DeclineInvitation: 'DeclineInvitation',
    RevokeIndividualInvitation: 'RevokeIndividualInvitation',
    RevokeOrganizationInvitation: 'RevokeOrganizationInvitation',
    // Member/Group Management
    RemoveMember: 'RemoveMember',
    // Used by FilespaceAdmin
    RequestRemoveMember: 'RequestRemoveMember',
    CreateGroup: 'CreateGroup',
    RemoveGroup: 'RemoveGroup',
    RemoveGroupMember: 'RemoveGroupMember',
    // Roles
    ChangeRole: 'ChangeRole',
    ConfirmChangeRole: 'ConfirmChangeRole',
    RoleChangedModal: 'RoleChangedModal',
    // Filespace
    FilespaceDetails: 'FilespaceDetails',
    // Infrastructure
    ServiceUnavailable: 'ServiceUnavailable',
    DeploymentInProgress: 'DeploymentInProgress',
};
